import { ISelectOption } from '../../../../../shared/form/element/base-select/select-option.interface';

export const getOptions = (): { [key: string]: ISelectOption[] } => {
    return {
        modeDial: optionsFromMap(eosModeDialMap),
        // fixedMovie: optionsFromMap(eosFixedMovieMap),
        apertureValue: optionsFromMap(eosApertureValueMap),
        focusMode: optionsFromMap(eosFocusModeMap),
        shootingMode: optionsFromMap(eosShootingModeMap),
        shutterSpeed: optionsFromMap(eosShutterSpeedMap),
        // whiteBalanceShiftBA: optionsFromMap(),
        isoSpeed: optionsFromMap(eosIsoSpeedMap),
        // colorTemperature, // input with validation int, 1000:2880
        driveMode: optionsFromMap(eosDriveModeMap),
        meteringMode: optionsFromMap(eosMeteringModeMap),
        exposure: optionsFromMap(eosExposureCompensationMap),
        whiteBalance: optionsFromMap(eosWhiteBalanceMap),
        stillPhotoImageQuality: stillPhotoImageQualityOptions(),
        aspectRatio: optionsFromMap(eosAspectRatioMap),
        autoPowerOffTime: optionsFromMap(eosAutoPowerOffMap),
    };
};

export const getOptionsShorten = (): { [key: string]: ISelectOption[] } => {
    return {
        apertureValue: optionsFromMap(eosApertureValueMapShorten),
        focusMode: optionsFromMap(eosFocusModeMap),
        shootingMode: optionsFromMap(eosShootingModeMapShorten),
        shutterSpeed: optionsFromMap(eosShutterSpeedMapShorten),
        // whiteBalanceShiftBA: optionsFromMap(),
        isoSpeed: optionsFromMap(eosIsoSpeedMapShorten),
        driveMode: optionsFromMap(eosDriveModeMapShorten),
        meteringMode: optionsFromMap(eosMeteringModeMap),
        exposure: optionsFromMap(eosExposureCompensationMap),
        whiteBalance: optionsFromMap(eosWhiteBalanceMapShorten),
        stillPhotoImageQuality: stillPhotoImageQualityOptionsShorten(),
        aspectRatio: optionsFromMap(eosAspectRatioMapShorten),
        autoPowerOffTime: optionsFromMap(eosAutoPowerOffMap),
    };
};

const optionsFromMap = (map: { [key: string]: any }): ISelectOption[] => {
    const options: { value: number; label: string }[] = [];
    for (const [value, label] of Object.entries(map)) {
        options.push({ value: Number(value), label });
    }

    return options;
};

const stillPhotoImageQualityOptions = (): ISelectOption[] => {
    const options: ISelectOption[] = [
        { value: [6, 0, 4].join('/'), label: 'RAW' },
        { value: [6, 0, 3].join('/'), label: 'CRAW' },
    ];
    for (const [imageSizeInt, imageSize] of Object.entries(stillPhotoImageQualityImageSizeMap)) {
        for (const [imageQualityInt, imageQuality] of Object.entries(stillPhotoImageQualityImageQualityMap)) {
            options.push({
                value: [1, imageSizeInt, imageQualityInt].join('/'),
                label: `JPEG/${imageSize}/${imageQuality}`,
            });
        }
    }

    return options;
};

const stillPhotoImageQualityOptionsShorten = (): ISelectOption[] => {
    const options: ISelectOption[] = [];
    for (const [imageSizeInt, imageSize] of Object.entries(stillPhotoImageQualityImageSizeMapShorten)) {
        for (const [imageQualityInt, imageQuality] of Object.entries(stillPhotoImageQualityImageQualityMapShorten)) {
            options.push({
                value: [1, imageSizeInt, imageQualityInt].join('/'),
                label: `JPEG/${imageSize}/${imageQuality}`,
            });
        }
    }

    return options;
};

const stillPhotoImageQualityImageSizeMap = {
    0x00: 'L',
    0x01: 'M',
    0x02: 'S',
    0x05: 'M1',
    0x06: 'M2',
    0x0e: 'S1',
    0x0f: 'S2',
    0x10: 'S3',
};

const stillPhotoImageQualityImageSizeMapShorten = {
    0x00: 'L',
    0x01: 'M',
    0x0e: 'S1',
    0x0f: 'S2',
};

const stillPhotoImageQualityImageQualityMap = {
    0x02: 'Normal',
    0x03: 'Fine',
    0x04: 'Lossless',
    0x05: 'SuperFine',
};
const stillPhotoImageQualityImageQualityMapShorten = {
    0x03: 'Fine',
};

const eosAspectRatioMap = {
    0x00: '3:2',
    0x01: '1:1',
    0x02: '4:3',
    0x07: '16:9',
};

const eosAspectRatioMapShorten = {
    0x00: '3:2',
    0x02: '4:3',
};

const eosModeDialMap = {
    0x00: 'P',
    0x01: 'Tv',
    0x02: 'Av',
    0x03: 'M',
    0x04: 'B',
    0x07: 'C1',
    0x10: 'C2',
    0x14: 'Video',
    0x16: 'Auto',
    0x19: 'SCN',
    0x1d: 'Creative Filters',
    0x37: 'Fv',
};

const eosDriveModeMap = {
    0x00: 'Single shooting',
    0x01: 'Continuous shooting',
    0x02: 'Video',
    0x04: 'High speed continuous',
    0x05: 'Low speed continuous',
    0x06: 'Single Silent shooting',
    0x07: 'Self-timer: Continuous',
    0x10: 'Self-timer: 10s',
    0x11: 'Self-timer: 2s',
    0x12: 'Super high speed shooting',
    0x13: 'Silent single shooting',
    0x14: 'Silent continuous shooting',
    0x15: 'Silent high speed continuous',
    0x16: 'Silent low speed continuous',
};
const eosDriveModeMapShorten = {
    0x00: 'Single shooting',
};

const eosMeteringModeMap = {
    0x01: 'Spot metering',
    0x03: 'Evaluative metering',
    0x04: 'Partial metering',
    0x05: 'Center-weighted averaging metering',
};

export const eosShutterSpeedMap = {
    0x0c: 'Bulb',
    0x10: '30"',
    0x13: '25"',
    0x14: '20"',
    0x15: '20"',
    0x18: '15"',
    0x1b: '13"',
    0x1c: '10"',
    0x1d: '10"',
    0x20: '8"',
    0x23: '6"',
    0x24: '6"',
    0x25: '5"',
    0x28: '4"',
    0x2b: '3"2',
    0x2c: '3"',
    0x2d: '2"5',
    0x30: '2"',
    0x33: '1"6',
    0x34: '1"5',
    0x35: '1"3',
    0x38: '1',
    0x3b: '0"8',
    0x3c: '0"7',
    0x3d: '0"6',
    0x40: '0"5',
    0x43: '0"4',
    0x44: '0"3',
    0x45: '0"3',
    0x48: '1/4',
    0x4b: '1/5',
    0x4c: '1/6',
    0x4d: '1/6',
    0x50: '1/8',
    0x53: '1/10',
    0x54: '1/10',
    0x55: '1/13',
    0x58: '1/15',
    0x5b: '1/20',
    0x5c: '1/20',
    0x5d: '1/25',
    0x60: '1/30',
    0x63: '1/40',
    0x64: '1/45',
    0x65: '1/50',
    0x68: '1/60',
    0x6b: '1/80',
    0x6c: '1/90',
    0x6d: '1/100',
    0x70: '1/125',
    0x73: '1/160',
    0x74: '1/180',
    0x75: '1/200',
    0x78: '1/250',
    0x7b: '1/320',
    0x7c: '1/350',
    0x7d: '1/400',
    0x80: '1/500',
    0x83: '1/640',
    0x84: '1/750',
    0x85: '1/800',
    0x88: '1/1000',
    0x8b: '1/1250',
    0x8c: '1/1500',
    0x8d: '1/1600',
    0x90: '1/2000',
    0x93: '1/2500',
    0x94: '1/3000',
    0x95: '1/3200',
    0x98: '1/4000',
    0x9b: '1/5000',
    0x9c: '1/6000',
    0x9d: '1/6400',
    0xa0: '1/8000',
};
export const eosShutterSpeedMapShorten = {
    0x10: '30"',
    0x13: '25"',
    0x14: '20"',
    0x15: '20"',
    0x18: '15"',
    0x1b: '13"',
    0x1c: '10"',
    0x1d: '10"',
    0x20: '8"',
    0x23: '6"',
    0x24: '6"',
    0x25: '5"',
    0x28: '4"',
    0x2b: '3"2',
    // 0x2c: '3"',
    0x2d: '2"5',
    0x30: '2"',
    0x33: '1"6',
    // 0x34: '1"5',
    0x35: '1"3',
    0x38: '1',
    0x3b: '0"8',
    // 0x3c: '0"7',
    0x3d: '0"6',
    0x40: '0"5',
    0x43: '0"4',
    0x44: '0"3',
    0x45: '0"3',
    0x48: '1/4',
    0x4b: '1/5',
    0x4c: '1/6',
    0x4d: '1/6',
    0x50: '1/8',
    0x53: '1/10',
    0x54: '1/10',
    0x55: '1/13',
    0x58: '1/15',
    0x5b: '1/20',
    0x5c: '1/20',
    0x5d: '1/25',
    0x60: '1/30',
    0x63: '1/40',
    // 0x64: '1/45',
    0x65: '1/50',
    0x68: '1/60',
    0x6b: '1/80',
    // 0x6c: '1/90',
    // 0x6d: '1/100',
    0x70: '1/125',
    0x73: '1/160',
    // 0x74: '1/180',
    0x75: '1/200',
    0x78: '1/250',
    0x7b: '1/320',
    // 0x7c: '1/350',
    0x7d: '1/400',
    0x80: '1/500',
    0x83: '1/640',
    // 0x84: '1/750',
    0x85: '1/800',
    0x88: '1/1000',
    0x8b: '1/1250',
    // 0x8c: '1/1500',
    0x8d: '1/1600',
    0x90: '1/2000',
    0x93: '1/2500',
    // 0x94: '1/3000',
    0x95: '1/3200',
    0x98: '1/4000',
    // 0x9b: '1/5000',
    // 0x9c: '1/6000',
    0x9d: '1/6400',
    0xa0: '1/8000',
};

export const eosIsoSpeedMap = {
    0x00: 'Auto',
    0x28: '6',
    0x30: '12',
    0x38: '25',
    0x40: '50',
    0x48: '100',
    0x4b: '125',
    0x4d: '160',
    0x50: '200',
    0x53: '250',
    0x55: '320',
    0x58: '400',
    0x5b: '500',
    0x5d: '640',
    0x60: '800',
    0x63: '1000',
    0x65: '1250',
    0x68: '1600',
    0x6b: '2000',
    0x6d: '2500',
    0x70: '3200',
    0x73: '4000',
    0x75: '5000',
    0x78: '6400',
    0x7b: '8000',
    0x7d: '10000',
    0x80: '12800',
    0x83: '16000',
    0x85: '20000',
    0x88: '25600',
    0x8b: '32000',
    0x8d: '40000',
    0x90: '51200',
    0x93: '64000',
    0x95: '80000',
    0x98: '102400',
    0xa0: '204800',
    0xa8: '409600',
    0xb0: '819200',
};
export const eosIsoSpeedMapShorten = {
    0x00: 'Auto',
    0x48: '100',
    0x4b: '125',
    0x4d: '160',
    0x50: '200',
    0x53: '250',
    0x55: '320',
    0x58: '400',
    0x5b: '500',
    0x5d: '640',
    0x60: '800',
    0x63: '1000',
    0x65: '1250',
    0x68: '1600',
    0x6b: '2000',
    0x6d: '2500',
    0x70: '3200',
    0x73: '4000',
    0x75: '5000',
    0x78: '6400',
    0x7b: '8000',
    0x7d: '10000',
    0x80: '12800',
    0x83: '16000',
    0x85: '20000',
    0x88: '25600',
    0x8b: '32000',
    0x8d: '40000',
    0x90: '51200',
};

export const eosWhiteBalanceMap = {
    0x00: 'Auto (Ambience priority)',
    0x01: 'Daylight',
    0x02: 'Cloudy',
    0x03: 'Tungsten',
    0x04: 'Fluorescent',
    0x05: 'Flash',
    0x06: 'Custom',
    0x08: 'Shade',
    0x09: 'Color temperature',
    0x0a: 'Custom: PC-1',
    0x0b: 'Custom: PC-2',
    0x0c: 'Custom: PC-3',
    0x0f: 'Manual 2',
    0x10: 'Manual 3',
    0x12: 'Manual 4',
    0x13: 'Manual 5',
    0x14: 'Custom: PC-4',
    0x15: 'Custom: PC-5',
    0x17: 'Auto (White priority)',
};
export const eosWhiteBalanceMapShorten = {
    0x00: 'Auto (Ambience priority)',
    0x06: 'Custom',
    0x17: 'Auto (White priority)',
};

export const eosExposureCompensationMap = {
    0x28: '+5 step',
    0x25: '+4 2/3 step',
    0x24: '+4 1/2 step',
    0x23: '+4 1/3 step',
    0x20: '+4 step',
    0x1d: '+3 2/3 step',
    0x1c: '+3 1/2 step',
    0x1b: '+3 1/3 step',
    0x18: '+3 step',
    0x15: '+2 2/3 step',
    0x14: '+2 1/2 step',
    0x13: '+2 1/3 step',
    0x10: '+2 step',
    0x0d: '+1 2/3 step',
    0x0c: '+1 1/2 step',
    0x0b: '+1 1/3 step',
    0x08: '+1 step',
    0x05: '+2/3 step',
    0x04: '+1/2 step',
    0x03: '+1/3 step',
    0x00: '0',
    0xfd: '-1/3 step',
    0xfc: '-1/2 step',
    0xfb: '-2/3 step',
    0xf8: '-1 step',
    0xf5: '-1 1/3 step',
    0xf4: '-1 1/2 step',
    0xf3: '-1 2/3 step',
    0xf0: '-2 step',
    0xed: '-2 1/3 step',
    0xec: '-2 1/2 step',
    0xeb: '-2 2/3 step',
    0xe8: '-3 step',
    0xe5: '-3 1/3 step',
    0xe4: '-3 1/2 step',
    0xe3: '-3 2/3 step',
    0xe0: '-4 step',
    0xdd: '-4 1/3 step',
    0xdc: '-4 1/2 step',
    0xdb: '-4 2/3 step',
    0xd8: '-5 step',
};

const eosShootingModeMap = {
    0x00: 'Program AE',
    0x01: 'Shutter-Speed Priority AE',
    0x02: 'Aperture Priority AE',
    0x03: 'Manual Exposure',
    0x04: 'Bulb',
    0x05: 'Auto Depth-of-Field AE',
    0x06: 'Depth-of-Field AE',
    0x07: 'Camera setting registered',
    0x08: 'Lock',
    0x09: 'Auto',
    0x0a: 'Night Scene Portrait',
    0x0b: 'Sports',
    0x0c: 'Portrait',
    0x0d: 'Landscape',
    0x0e: 'Close-Up',
    0x0f: 'Flash Off',
    0x13: 'Creative Auto',
    0x16: 'Scene Intelligent Auto',
    0x17: 'Night Scenes',
    0x18: 'Backlight Scenes',
    0x1a: 'Kids',
    0x1b: 'Food',
    0x1c: 'Candlelight',
    0x1e: 'Grainy B/W',
    0x1f: 'Soft focus',
    0x20: 'Toy camera effect',
    0x21: 'Fish-eye effect',
    0x22: 'Water painting effect',
    0x23: 'Miniature effect',
    0x14: 'Movies',
    0x15: 'Photo In Movie',
    0x24: 'HDR Art standard',
    0x25: 'HDR Art vivid',
    0x26: 'HDR Art bold',
    0x27: 'HDR Art embossed',
    0x28: 'Dream',
    0x29: 'Old movies',
    0x2a: 'Memory',
    0x2b: 'Dramatic B/W',
    0x2c: 'Miniature effect movie',
    0x2d: 'Panning',
    0x2e: 'Group Photo',
    0x32: 'Myself (Self portrait)',
    0x34: 'SmoothSkin',
    0x33: 'Plus Movie Auto',
    0x36: 'Silent mode',
    0x37: 'Flexible-Priority AE',
    0x38: 'Oil painting (Art bold effect)',
    0x39: 'Fireworks',
    0x3a: 'Star portrait',
    0x3b: 'Star nightscape',
    0x3c: 'Star trails',
    0x3d: 'Star time-lapse movie',
    0x3e: 'Background blur',
};
const eosShootingModeMapShorten = {
    0x00: 'Program AE',
    0x01: 'Shutter-Speed Priority AE',
    0x02: 'Aperture Priority AE',
    0x03: 'Manual Exposure',
    0x08: 'Lock',
    0x0f: 'Flash Off',
};

export const eosApertureValueMap = {
    0x08: 'F1.0',
    0x0b: 'F1.1',
    0x0c: 'F1.2',
    0x0d: 'F1.2',
    0x10: 'F1.4',
    0x13: 'F1.6',
    0x14: 'F1.8',
    0x15: 'F1.8',
    0x18: 'F2.0',
    0x1b: 'F2.2',
    0x1c: 'F2.5',
    0x1d: 'F2.5',
    0x20: 'F2.8',
    0x23: 'F3.2',
    0x24: 'F3.5',
    0x25: 'F3.5',
    0x28: 'F4.0',
    0x2b: 'F4.5',
    0x2c: 'F4.5',
    0x2d: 'F5.0',
    0x30: 'F5.6',
    0x33: 'F6.3',
    0x34: 'F6.7',
    0x35: 'F7.1',
    0x38: 'F8.0',
    0x3b: 'F9.0',
    0x3c: 'F9.5',
    0x3d: 'F10',
    0x40: 'F11',
    0x43: 'F13', // 1/3 step, our cameras
    0x44: 'F13', // 1/2 step, not our cameras
    0x45: 'F14',
    0x48: 'F16',
    0x4b: 'F18',
    0x4c: 'F19',
    0x4d: 'F20',
    0x50: 'F22',
    0x53: 'F25',
    0x54: 'F27',
    0x55: 'F29',
    0x58: 'F32',
    0x5b: 'F36',
    0x5c: 'F38',
    0x5d: 'F40',
    0x60: 'F45',
    0x63: 'F51',
    0x64: 'F54',
    0x65: 'F57',
    0x68: 'F64',
    0x6b: 'F72',
    0x6c: 'F76',
    0x6d: 'F80',
    0x70: 'F91',
};
export const eosApertureValueMapShorten = {
    0x20: 'F2.8',
    0x23: 'F3.2',
    0x24: 'F3.5',
    0x25: 'F3.5',
    0x28: 'F4.0',
    0x2b: 'F4.5',
    0x2c: 'F4.5',
    0x2d: 'F5.0',
    0x30: 'F5.6',
    0x33: 'F6.3',
    0x34: 'F6.7',
    0x35: 'F7.1',
    0x38: 'F8.0',
    0x3b: 'F9.0',
    0x3c: 'F9.5',
    0x3d: 'F10',
    0x40: 'F11',
    0x43: 'F13',
    0x45: 'F14',
    0x48: 'F16',
    0x4b: 'F18',
    0x4c: 'F19',
    0x4d: 'F20',
    0x50: 'F22',
};

const eosFocusModeMap = {
    0x00: 'One-Shot AF',
    0x01: 'AI Servo AF',
    0x02: 'AI Focus AF',
    0x03: 'Manual Focus',
};

export const eosAutoPowerOffMap = {
    0: 'Disabled',
};
